/** Import React section */
import React from 'react'
import PropTypes from 'prop-types'

/** Import TinyMCE section */
import { Editor } from '@tinymce/tinymce-react'

/** Import config section */
import appConfig from '../../app.config'

const TOOLBAR = 'bold italic underline | bullist numlist | alignleft aligncenter alignright alignjustify | fontsizeselect | forecolor backcolor'

const getApiKey = () => (window.config && window.config.tinyMceApiKey) || appConfig.tinyMceApiKey

const RichTextEditor = (props) => {
	const { value, onChange, disabled, name, id } = props

	const onEditorChangeHandler = (content) => {
		if (onChange) {
			onChange(content)
		} else {
			console.warn('onChange callback not found.')
		}
	}

	return (
		<Editor
			id={id}
			apiKey={getApiKey()}
			textareaName={name}
			value={value || ''}
			disabled={disabled}
			onEditorChange={onEditorChangeHandler}
			init={{
				menubar: false,
				plugins: 'lists',
				toolbar: TOOLBAR,
				branding: false,
				invalid_elements: 'script,iframe,object,embed,form,style',
				invalid_styles: 'position'
			}}
		/>
	)
}

RichTextEditor.propTypes = {
	value: PropTypes.string,
	name: PropTypes.string,
	id: PropTypes.string,
	disabled: PropTypes.bool,
	onChange: PropTypes.func
}

RichTextEditor.defaultProps = {
	value: '',
	disabled: false
}

export default RichTextEditor
